import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Icon } from '../icons';
import { appRolleLabel } from '../../verwaltung/rollen';

interface TopBarProps {
  mobileOpen: boolean;
  onOpenMobile: () => void;
  onOpenSearch: () => void;
}

/**
 * Kopfzeile wie in itsm: Hamburger (mobil), Suchfeld fuer die Befehlspalette,
 * rechts Name und App-Rolle auf Deutsch (Link zum Profil) sowie Abmelden.
 */
const TopBar: React.FC<TopBarProps> = ({ mobileOpen, onOpenMobile, onOpenSearch }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate('/login');
    }
  };

  return (
    <header className="app-topbar">
      <button
        type="button"
        className="app-topbar__menu"
        aria-label="Menü öffnen"
        aria-controls="app-sidebar"
        aria-expanded={mobileOpen}
        onClick={onOpenMobile}
      >
        <Icon name="menu" size={20} />
      </button>
      <button
        type="button"
        className="app-search-trigger"
        onClick={onOpenSearch}
        title="Seite oder Aktion suchen (Strg+K)"
      >
        <Icon name="search" size={14} />
        <span className="app-search-trigger__label">Suchen…</span>
        <kbd className="app-search-trigger__kbd" aria-hidden="true">Strg K</kbd>
      </button>
      <div className="app-topbar__spacer" />
      {user && (
        // Fuer jede angemeldete Person: eigenes LinkedIn-, X-, Instagram-Konto verbinden.
        <Link to="/mein-profil" className="btn btn-secondary btn-sm app-mein-profil" title="Eigenes LinkedIn-, X- oder Instagram-Konto verbinden">
          <Icon name="link" size={14} />
          <span className="app-logout__label">Mein Profil verbinden</span>
        </Link>
      )}
      {user && (
        <Link to="/profile" className="app-user" title="Profil">
          <span className="app-user__name">{user.name}</span>
          <span className="app-user__role">{appRolleLabel(user).label}</span>
        </Link>
      )}
      <button type="button" className="btn btn-secondary app-logout" onClick={handleLogout}>
        <Icon name="logout" size={14} />
        <span className="app-logout__label">Abmelden</span>
      </button>
    </header>
  );
};

export default TopBar;
